import { InvoicesActionTypes } from "./constants";

const INIT_STATE = {
  list: [],
  total: 0,
  one: null,
  loading: false,
  updated: false,
};

interface InvoicesData {
  items?: any[];
  total?: number;
}

interface GetInvoicesData {
  id: string;
}

interface InvoicesActionType {
  type:
    | InvoicesActionTypes.GET_LIST_INVOICES
    | InvoicesActionTypes.GET_LIST_INVOICES_ERROR
    | InvoicesActionTypes.GET_LIST_INVOICES_SUCCESS
    | InvoicesActionTypes.GET_INVOICE
    | InvoicesActionTypes.GET_INVOICE_SUCCESS
    | InvoicesActionTypes.GET_INVOICE_ERROR
    | InvoicesActionTypes.UPDATE_STATUS_INVOICE
    | InvoicesActionTypes.UPDATE_STATUS_INVOICE_SUCCESS
    | InvoicesActionTypes.UPDATE_STATUS_INVOICE_ERROR
    | InvoicesActionTypes.UPDATE_INVOICE
    | InvoicesActionTypes.UPDATE_INVOICE_SUCCESS
    | InvoicesActionTypes.UPDATE_INVOICE_ERROR;
  payload: {
    actionType?: string;
    data?: InvoicesData;
    getInvoice?: GetInvoicesData;
    error?: string;
    updated: false;
    refreshList: false;
  };
}

interface State {
  list?: any[];
  total?: number;
  one?: any;
  loading?: boolean;
  updated?: boolean;
  value?: boolean;
}

const Invoices = (
  state: State = INIT_STATE,
  action: InvoicesActionType
): any => {
  switch (action.type) {
    case InvoicesActionTypes.GET_INVOICE:
      return {
        ...state,
        list: [],
        one: null,
        loading: true,
        error: "",
        total: 0,
        updated: false,
      };

    case InvoicesActionTypes.GET_INVOICE_SUCCESS:
      switch (action.payload.actionType) {
        case InvoicesActionTypes.GET_INVOICE: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: action.payload.data,
            error: "",
            updated: false,
          };
        }
        default:
          return { ...state };
      }

    case InvoicesActionTypes.GET_INVOICE_ERROR:
      switch (action.payload.actionType) {
        case InvoicesActionTypes.GET_INVOICE: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: null,
            error: action.payload.error,
            updated: false,
          };
        }
        default:
          return { ...state };
      }

    case InvoicesActionTypes.UPDATE_STATUS_INVOICE:
      return {
        ...state,
        list: [],
        one: null,
        loading: true,
        error: "",
        total: 0,
        refreshList: false,
      };

    case InvoicesActionTypes.UPDATE_STATUS_INVOICE_SUCCESS:
      switch (action.payload.actionType) {
        case InvoicesActionTypes.UPDATE_STATUS_INVOICE: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: action.payload.data,
            error: "",
            updated: true,
            refreshList: true,
          };
        }
        default:
          return { ...state };
      }

    case InvoicesActionTypes.UPDATE_STATUS_INVOICE_ERROR:
      switch (action.payload.actionType) {
        case InvoicesActionTypes.UPDATE_STATUS_INVOICE: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: null,
            error: action.payload.error,
            refreshList: false,
          };
        }
        default:
          return { ...state };
      }

    case InvoicesActionTypes.GET_LIST_INVOICES_SUCCESS:
      switch (action.payload.actionType) {
        case InvoicesActionTypes.GET_LIST_INVOICES: {
          return {
            ...state,
            list: action.payload.data.items,
            loading: false,
            total: action.payload.data.total,
            one: null,
            error: "",
            updated: false,
            refreshList: false,
          };
        }
        default:
          return { ...state };
      }

    case InvoicesActionTypes.GET_LIST_INVOICES_ERROR:
      switch (action.payload.actionType) {
        case InvoicesActionTypes.GET_LIST_INVOICES: {
          // Voir Orders : on garde list/total pour éviter le flash "vide"
          // sur un 401 pendant refresh token / blip réseau.
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            updated: false,
            refreshList: false,
          };
        }
        default:
          return { ...state };
      }

    case InvoicesActionTypes.GET_LIST_INVOICES:
      return {
        ...state,
        loading: true,
        one: null,
        error: "",
        updated: false,
        refreshList: false,
      };

    case InvoicesActionTypes.UPDATE_INVOICE:
      return {
        ...state,
        list: [],
        one: null,
        loading: true,
        error: "",
        total: 0,
      };
    case InvoicesActionTypes.UPDATE_INVOICE_SUCCESS:
      switch (action.payload.actionType) {
        case InvoicesActionTypes.UPDATE_INVOICE: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: action.payload.data,
            error: "",
            updated: true,
          };
        }
        default:
          return { ...state };
      }

    case InvoicesActionTypes.UPDATE_INVOICE_ERROR:
      switch (action.payload.actionType) {
        case InvoicesActionTypes.UPDATE_INVOICE: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: null,
            error: action.payload.error,
          };
        }
        default:
          return { ...state };
      }
    default:
      return { ...state };
  }
};

export default Invoices;
